import React from "react";
import Modal from "react-modal";
import './Alert.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"260px",
		minHeight:"140px",
		transform: "translate(-50%, -50%)"
	}
};

function Alert ({message,close,isOpen}){
 	const afterOpenModal = ()=>{
		
	}
 	const closeYes = ()=>{
		close(true);
	}
	const closeNo = ()=>{
		close(false);
	}
	const btns = (
		<div className="btns">
			<button
				className="confirm"
				onClick={closeYes}
			>YES</button>
			<button
				className="confirm"
				onClick={closeNo}
			>NO</button>
		</div>
	);
	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={closeNo}
			onAfterOpen={afterOpenModal}
			style={customStyles}
		>
		<div id="alert">
			<div className="text">{message}</div>
			{btns}
		</div>
		</Modal>
	);
}

export default Alert;